// extracted by mini-css-extract-plugin
module.exports = {"legend-item":"legend-item___2KwSs","is-reverse":"is-reverse___cP1oA","legend-label":"legend-label___2KPob","square":"square___2WE9w","triangle":"triangle___2HVjq"};